import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import PageBase from '../../../app/PageBase';
import Table from '../../table/MsTable';
import { getAllInvoices } from '../../../redux/actions/invoiceActions';


import { setInvoiceData } from '../../../redux/invoice';

const mapStateToProps = state => ({
  open: state.invoiceReducer.open,
  invoiceId: state.invoiceReducer.invoiceId,
  invoiceList: state.invoiceReducer.invoiceList,
});

const mapDispatchToProps = {
  setInvoiceData,
  getAllInvoices,
};

class InvoiceContainer extends Component {


  static propTypes = {

  };

  constructor(props) {

    super(props);

    this.state = {
      data: {},
      deleteOpen: false,
      showTableActions: false,
    };


  }


  componentWillMount() {

    this.getInvoice();

  }

  getInvoice() {

    const { user, getAllInvoices, setInvoiceData } = this.props;

    const payLoadParams = {
      holdingId: user.context.idHolding,
      companyid: user.context.idCompany,
    };

    getAllInvoices(payLoadParams).then(response => setInvoiceData({ invoiceList: response }));

  }

  handleCreateClick = () => {

    this.props.history.push('/invoice/form/');
    this.props.setInvoiceData({ invoiceId: null });

  }


  render() {

    const { invoiceList } = this.props;


    return (
      <div>


        <PageBase
          title={I18n.t('titles.invoiceList')}
          navigation={`Configurações -> ${I18n.t('menu.invoice')}`}
          showCreateButton={true}
          showEditButton={false}
          showDeleteButton={false}
          handleCreateClick={this.handleCreateClick}
        >
          {
            invoiceList.length > 0 ? (
              <Table
                data={invoiceList}
                entryKey="idInvoice"
                paginate
                onPaginate={this.onPaginate}
                toolbar
                selectable={false}
                tableDef={[
                  { name: 'codeBar', label: I18n.t('fields.codeBar') },
                  { name: 'invoiceNumber', label: I18n.t('fields.invoiceNumber') },
                  { name: 'workflowName', label: I18n.t('fields.workflow') },
                  { name: 'userName', label: I18n.t('fields.username') },
                  { name: 'companyName', label: I18n.t('fields.company') },
                ]}
              />
            ) : (
              <p>Não há notas cadastradas.</p>
            )
          }


        </PageBase>


      </div>
    );

  }

}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceContainer);



// WEBPACK FOOTER //
// ./src/components/tracker/Invoices/InvoiceContainer.js